import React, { useCallback } from 'react';
import { Flex, List, Text } from '@leverege/ui-elements';
import { useWizard } from '@leverege/ui-wizard';
import I18N from '@leverege/i18n';
import S from './LocatorPairingSelectionRenderer.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('pairing.imagine.PairingSelectionRenderer');
function LocatorPairingSelectionRenderer(props) {
  const {
    item: locator,
    name,
    onChange: pOnChange,
    eventData
  } = props;
  const {
    context,
    setActiveStep
  } = useWizard();
  const {
    parentAttribute,
    relationship
  } = context;
  const assetId = parentAttribute.get(locator);
  function isLocatorOffline(locator) {
    const lastHeartbeat = locator?.data?.lastHeartbeat;
    const effectiveHeartbeatInterval = locator?.data?.effectiveHeartbeatInterval;

    // If no heartbeat or no heartbeat interval data, consider offline
    if (!lastHeartbeat) {
      return true;
    }

    // Check if last heartbeat is older than 3 * effective heartbeat interval
    const offlineThreshold = effectiveHeartbeatInterval ? effectiveHeartbeatInterval * 1000 * 3 : 2 * 60 * 60 * 1000;
    const currentTime = Date.now();
    const cutoffTime = currentTime - offlineThreshold;
    const isOffline = lastHeartbeat < cutoffTime;
    return isOffline;
  }
  function isLocatorUnactivated(locator) {
    const lastHeartbeat = locator?.data?.lastHeartbeat;
    return !lastHeartbeat;
  }
  const onClick = useCallback(({
    item
  }) => {
    const evt = {
      data: eventData,
      value: item
    };
    try {
      // Check if locator is unactivated
      const isUnactivated = isLocatorUnactivated(locator);
      if (isUnactivated) {
        setActiveStep('locatorUnactivated');
        return;
      }

      // Check if locator is offline
      const isOffline = isLocatorOffline(locator);
      if (isOffline) {
        setActiveStep('locatorOffline');
        return;
      }

      // If already paired, follow default behavior
      if (assetId) {
        pOnChange(evt);
        setActiveStep('tagPaired');
      } else {
        pOnChange(evt);
      }
    } catch (err) {
      // If there's an unexpected error, go to the default error screen
      setActiveStep('pairingError');
    }
  }, [pOnChange, assetId, setActiveStep, eventData, locator]);
  return /*#__PURE__*/_jsx(List.Item, {
    className: S.listItem,
    item: locator.id,
    onClick: onClick,
    children: /*#__PURE__*/_jsxs(Flex, {
      variant: "rowM",
      align: "baseline",
      children: [/*#__PURE__*/_jsx("i", {
        className: "fa fa-fw fa-search"
      }), /*#__PURE__*/_jsxs(Flex, {
        variant: "colS",
        children: [/*#__PURE__*/_jsx(Text, {
          children: name
        }), assetId && /*#__PURE__*/_jsx(Text, {
          variant: "pairingErrorSubtitle",
          children: t('alreadyPaired', {
            blueprintName: relationship.blueprint.name
          })
        })]
      })]
    })
  }, locator.id);
}
export default {
  id: 'pairing.imagine.locator.pair.LocatorPairingSelectionRenderer',
  sort: 'a',
  component: LocatorPairingSelectionRenderer,
  matches: {
    actionType: 'pair',
    objectType: 'locator'
  }
};